import { render, staticRenderFns } from "./rejectTicketFcp.vue?vue&type=template&id=5431e0f0&lang=pug"
import script from "./rejectTicketFcp.vue?vue&type=script&lang=js"
export * from "./rejectTicketFcp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports